import { Button, Col, Row } from "antd";
import { JustifyOption, Link as SimplePaginationLink } from "@customTypes/index";
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

interface SimplePaginationProps {
    className?: string;
    style?: string;
    next: SimplePaginationLink;
    previous: SimplePaginationLink;
    justify: JustifyOption
}

const defaultProps: SimplePaginationProps = {
    justify: `space-between`,
    next: {
        name: '',
        url: '',
        target: '_self',
    },
    previous: {
        name: '',
        url: '',
        target: '_self',
    },
};

const SimplePagination = ({ className, next, previous, justify }: SimplePaginationProps) => {

    return (
        <Row className={`simple-pagination ${className}`} justify={justify}>
            {previous.url
                && <Col>
                    <Button href={previous.url} target={previous.target} title={previous.name}>
                        <ArrowLeftOutlined /> Previous Page
                    </Button>
                </Col>}
            {next.url
                && <Col>
                    <Button href={next.url} target={next.target} title={next.name}>
                        Next Page <ArrowRightOutlined />
                    </Button>
                </Col>}
        </Row>
    );
};

SimplePagination.defaultProps = defaultProps;

export default SimplePagination;
